<template>
    <div>
        <v-badge v-if="pendingMessage" color="secondary" :content="quantityMessages" offset-x="20" offset-y="20"
                 bordered>
            <v-btn icon @click="toChat">
                <v-icon color="secondary">mdi-message-processing-outline</v-icon>
            </v-btn>
        </v-badge>
        <v-btn v-else icon @click="toChat">
            <v-icon color="secondary">mdi-message-processing-outline</v-icon>
        </v-btn>
    </div>
</template>

<script>

export default {
    components: {
        //
    },
    computed: {
        pendingMessage(vm = this) {
            return !!(vm.account && vm.account.counter && vm.account.counter.messages > 0)
        },
        quantityMessages(vm = this) {
            if (vm.pendingMessage) return vm.account.counter.messages
            return 0
        },
    },
    methods: {
        toChat() {
            var vm = this
            vm.$router.push({name: 'coach.students.chats'})
        }
    },
}
</script>